import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GeneralModal } from '@framework/ui/elements/GeneralModal';
import type { Editor } from '@tiptap/core';
import { Button } from '@framework/ui/atoms/Button';
import { Input } from '@framework/ui/atoms/Input';
type Props = {
  isOpen: boolean;
  editor: Editor | null;
  onClose(): void;
};

export const DescriptionEditorSetUrlModal: React.FC<Props> = ({ isOpen, editor, onClose }: Props) => {
  const { t } = useTranslation();
  const [url, setUrl] = useState<string>('');

  useEffect(() => {
    if (editor && isOpen) {
      const previousUrl = editor.getAttributes('link').href;
      setUrl(previousUrl);
    }
  }, [editor, isOpen]);

  const handleSubmit = useCallback(() => {
    if (!editor) return;
    if (url === '') {
      editor.chain().focus().extendMarkRange('link').unsetLink().run();
    } else {
      editor.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
      setUrl('');
    }
    onClose();
  }, [editor, onClose, url]);

  return (
    <GeneralModal
      isOpen={isOpen}
      onClose={onClose}
      title={t('canvas.descriptionPanel.setUrl.title')}
      submitButton={
        <Button color="primary" onClick={handleSubmit}>
          {t('common.action.save')}
        </Button>
      }
      cancelButton={
        <Button color="secondary" onClick={onClose}>
          {t('common.action.cancel')}
        </Button>
      }
    >
      <div className="p-4">
        <div className="pb-2 font-bold">{t('canvas.descriptionPanel.setUrl.urlLabel')}</div>
        <Input
          type="text"
          placeholder={t('canvas.descriptionPanel.setUrl.urlPlaceholder')}
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          autoFocus={true}
        />
      </div>
    </GeneralModal>
  );
};
